import { render, staticRenderFns } from "./userInfoPC.vue?vue&type=template&id=0a4c4385&scoped=true"
import script from "./userInfoPC.vue?vue&type=script&lang=js"
export * from "./userInfoPC.vue?vue&type=script&lang=js"
import style0 from "./userInfoPC.vue?vue&type=style&index=0&id=0a4c4385&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a4c4385",
  null
  
)

export default component.exports